import { useNavigate } from 'react-router-dom';
import { useShopifyCartStore } from '@/stores/cartStore';

export const ShopifyCartDrawer = () => {
  const navigate = useNavigate();
  const { items } = useShopifyCartStore();
  const totalItems = items.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <button
      onClick={() => navigate('/checkout')}
      aria-label={`Shopping cart${totalItems > 0 ? ` (${totalItems} items)` : ''}`}
      className="relative flex items-center justify-center w-8 h-8 rounded-full border border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
    >
      <span className="text-sm font-medium">{totalItems}</span>
    </button>
  );
};
